<template>
  <div id="app">
    <header>
      <div class="navbar has-shadow">
        <div class="container">
            <div class="navbar-brand">
              <h1><router-link to="/">EZARCH</router-link><div class="fb-like" data-href="https://www.facebook.com/ezarchs" data-layout="button_count" data-action="like" data-size="small" data-show-faces="false" data-share="false"><iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fezarchs&width=75&layout=button_count&action=like&size=small&show_faces=false&share=false&height=21&appId=1350135241775221" width="75" height="21" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true"></iframe></div></h1><em>防水 透氣 環保 耐久</em>
              <span class="navbar-burger" v-on:click="toggleNav" v-bind:class="{ 'is-active' : isActive }">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
          </div>
      </div>
      <nav id="navigate"role="navigation" aria-label="main navigation">
        <div class="container">
          <div class="navbar-menu" v-bind:class="{ 'is-active' : isActive }">
            <div class="navbar-start">
              <router-link to="/" class="navbar-item r-item"><span v-on:click="toggleNav">Home</span></router-link>
              <router-link to="/faq" class="navbar-item r-item"><span v-on:click="toggleNav">樂土Q&A</span></router-link>
              <!-- <router-link to="/faq" class="navbar-item r-item"><span v-on:click="toggleNav">案例分享</span></router-link>-->
              <router-link to="/product" class="navbar-item r-item"><span v-on:click="toggleNav">樂土產品列表</span></router-link>
              <router-link to="/contact" class="navbar-item r-item"><span v-on:click="toggleNav">聯絡我們</span></router-link>
              <a href="https://blog.ezarch.com.tw" class="navbar-item r-item blog" target="_blank" v-on:click="toggleNav">官方部落格</a>
            </div>
            <div class="navbar-end">
              <div class="navbar-item">
                <a class="button is-primary is-outlined call-in-action" href="https://shop.ezarch.com.tw" target="_blank">
                  <span class="icon">
                    <i class="fa fa-credit-card"></i>
                  </span>
                  <span>購買樂土產品</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
    
    <main>
    <router-view></router-view>
    </main>
    <footer class="footer is-primary">
      <div class="container">
        <div class="columns is-gapless">
          <div class="column">
            <ul class="links">
              <li><router-link to="/"><span class="icon"><i class="fa fa-home fa-lg" aria-hidden="true"></i></span>Home</router-link></li>
              <li><router-link to="/faq"><span class="icon"><i class="fa fa-question-circle fa-lg" aria-hidden="true"></i></span>樂土Q&A</router-link></li>
              <li><router-link to="/product"><span class="icon"><i class="fa fa-shopping-cart fa-lg" aria-hidden="true"></i></span>產品列表</router-link></li>
              <!-- <li><router-link to="/faq"><span class="icon"><i class="fa fa-product-hunt fa-lg" aria-hidden="true"></i></span>案例分享</router-link></li>-->
              <li><router-link to="/contact"><span class="icon"><i class="fa fa-connectdevelop fa-lg" aria-hidden="true"></i></span>聯絡我們</router-link></li>
              <li><a href="https://blog.ezarch.com.tw" target="_blank"><span class="icon"><i class="fa fa-info-circle fa-lg" aria-hidden="true"></i></span>官方部落格</a></li>

            </ul>
          </div>
          <div class="column">
            <ul class="contact">
              <li><a href="mailto:service@ezarch.com.tw"><span class="icon"><i class="fa fa-envelope-o fa-lg" aria-hidden="true"></i></span>service@ezarch.com.tw</a></li>
              <li><a href="tel:0931247688"><span class="icon"><i class="fa fa-mobile fa-lg" aria-hidden="true"></i></span>0931-247-688</a></li>
              <li><a href="tel:0287976155"><span class="icon"><i class="fa fa-phone-square fa-lg" aria-hidden="true"></i></span>02-87976155</a></li>
            </ul>
          </div>
          <div class="column">
            <ul class="social">
              <li><a href="https://www.facebook.com/ezarchs/" target="_blank"><span class="icon"><i class="fa fa-facebook-official fa-lg"></i></span>Facebook粉絲團</a></li>
              <li><a href="https://www.instagram.com/ezarch55/" target="_blank"><span class="icon"><i class="fa fa-instagram fa-lg"></i></span>Instagram</a></li>
              <li><a href="https://line.me/ti/p/%40xqw0055x" target="_blank"><img border="0" alt="好友人數" src="https://i2.wp.com/biz.line.naver.jp/line_business/img/btn/addfriends_zh-Hant.png?fit=720%2C36&amp;ssl=1" width="107" height="36"></a></li>
            </ul>
          </div>
          <div class="column">
              <p><span class="icon"><i class="fa fa-copyright" aria-hidden="true"></i></span>{{ thisYear }} EZARCH.inc  版權所有.</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data: function() {
    return {
      isActive: false,
      thisYear: (new Date()).getFullYear()
    }
  },
  methods: {
    toggleNav: function() {
      this.isActive = !this.isActive;
    }
  }
}
</script>

<style lang="sass">
@import "../node_modules/bulma/sass/utilities/initial-variables"
@import "../node_modules/bulma/sass/utilities/functions"
@import 'mq'
@import '../node_modules/bulma/bulma'

header
  h1 
    position: relative
    .fb-like
      position: absolute
      top: -4px
      right: -82px
    a
      display: block;
      background: url('assets/logo.png') no-repeat left top
      width:  121px
      height: 50px
      text-indent: -300000px
    +desktop
        margin: 1rem 0
  em 
    position: relative
    top: 25px
    left: 10px
    font-size: 0.8rem
    color: #396ab3
    letter-spacing: 1px
    font-weight: bold
    font-style: normal
    +desktop
      top: 45px
#navigate
  background-color: #58585a
  .navbar-menu
    background-color: #58585a
  a.r-item
    color: #fff
    padding: 0.5rem 0
    letter-spacing: 1px
    span
      display: block
      padding: 0 2rem
      @media screen and (min-width: $desktop)
          border-right: 1px solid gray
  a:hover
    background-color: #396ab3
  a.blog
    padding: 0.5rem 2rem

  .call-in-action
    color: #fff
    border: 1px solid #fff
    background: #396ab3
    font-weight: bold


footer
  background-color: $primary !important
  color: #fff
  padding: 2rem 1rem !important
  .links
    display: none
    +tablet
        display: block

  a 
    display: block
  .links, .contact, .social
    .icon 
      margin-right: 3px
    li 
      line-height: 2.5
    a 
      color: #fff


</style>



// WEBPACK FOOTER //
// src/App.vue